import React from "react";
import "../../../../../Assets/Styles/TypingIndicator.scss";

const TypingIndicator = () => {
  return (
    <div className="typing-indicator-wrapper">
      <div className="col-3">
        <div className="snippet" data-title=".dot-flashing">
          <div className="stage">
            <div className="dot-flashing"></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TypingIndicator;
